export default "__VITE_ASSET__1b27f72b__"